export default {"src":"/_next/static/media/loading-dot.49c08608.svg","height":6,"width":5};